module.exports = __webpack_public_path__ + "static/media/galerija_2023 (14).3fca7c92.png";